import { render } from "./AddProvider.vue?vue&type=template&id=1e0ab31b"
import script from "./AddProvider.vue?vue&type=script&lang=js"
export * from "./AddProvider.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.7\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__